import { useState, useRef } from "react";
import Loader from "../../components/loader";
import { Row, Col } from "react-bootstrap";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import { useNetworkOptions } from "../../context/contractDataLoaderService";
import Web3 from "web3";
import { Liquidity, contractAddress } from "@verified-network/verified-sdk";

import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../utils/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProvider,
  getProviderNetwork,
  getWeb3,
} from "../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function NewManager(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  const [loading, setLoading] = useState(false);
  const [managerAddress, setManagerAddress] = useState("");
  const [changeContent, setChangeContent] = useState(false);
  const { data: networkOptions } = useNetworkOptions();
  const modalContent = useRef(null);

  let liquidityContract;
  if (provider && provider.getSigner && chainId && address) {
    liquidityContract = new Liquidity(
      signer,
      contractAddress[chainId].Liquidity
    );
  }
  const addNewManager = async () => {
    if (!web3.utils.isAddress(managerAddress)) {
      alert("Enter proper manager address");
    }
    setLoading(true);
    const platformAddress = props.data.platformAddress;

    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await liquidityContract._getMeeQuote(
          cashTokens[0]?.address,
          "addManager",
          [platformAddress, managerAddress]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await liquidityContract
        .addManager(
          platformAddress,
          managerAddress,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          if (res?.status === 0) {
            setLoading(false);
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction Failed.", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Manager address</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Address"
                onChange={(e) => setManagerAddress(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  addNewManager();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Add"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function AddManager(props) {
  return <NewManager {...props} />;
}
